import {useEffect, useState} from 'react'

import {changeDispatcher} from '~/services/cache/profileCache'
import {getProfile} from '~/services/http/profile'

import type {BackendError} from '~/types/error'
import type {Profile} from '~/types/profile'

// TODO: если ничего не прибавиться после того как появится бек - лучше переделать на useProfile
export function useAuth(errorHandler?: (error: BackendError) => void) {
    const [auth, setAuth] = useState<{profile?: Profile}>()
    const [ready, setReady] = useState(false)

    useEffect(
        () => {
            const refresh = () => {
                setReady(false)
                getProfile()
                    .catch((error: BackendError) => {
                        errorHandler?.(error)
                        throw error
                    })
                    .catch(() => undefined)
                    .then(profile => setAuth(profile ? {profile} : {}))
                    .finally(() => setReady(true))
            }

            refresh()

            return changeDispatcher.subscribe(refresh)
        },
        [errorHandler],
    )

    return {auth, ready}
}
